import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { Meta, Response as ApiResponse } from '@/types/api/response.types';
import {
  Cart,
  AddCartItemBody,
  EditCartItemBody,
  AddCartItemResponse,
  UpdateCartDetailBody,
} from '@/types/api/carts.types';

const resource = 'boqs';
const subResource = 'carts/items';

// Item operations
export const addItemToCart = async (
  boqId: string,
  data: AddCartItemBody,
): Promise<AxiosResponse<ApiResponse<AddCartItemResponse>>> => {
  return axiosRequest().post(`${resource}/${boqId}/${subResource}`, data);
};

export const editItemInCart = async (
  boqId: string,
  itemId: string,
  data: EditCartItemBody,
): Promise<AxiosResponse<ApiResponse<Cart>>> => {
  return axiosRequest().patch(`${resource}/${boqId}/${subResource}/${itemId}`, data);
};

export const deleteItemFromCart = async (
  boqId: string,
  itemId: string,
): Promise<AxiosResponse<ApiResponse<Meta>>> => {
  return axiosRequest().delete(`${resource}/${boqId}/${subResource}/${itemId}`);
};

// Cart operations
export const deleteCart = async (boqId: string): Promise<AxiosResponse<ApiResponse<Meta>>> => {
  return axiosRequest().delete(`${resource}/${boqId}/${subResource}`);
};

export const getCartDetails = async (boqId: string) => {
  return axiosRequest().get(`${resource}/${boqId}/carts`);
};

export const updateCartDetails = async (boqId: string, data: UpdateCartDetailBody) => {
  return axiosRequest().put(`${resource}/${boqId}/carts`, data);
};
